import { createContext, useContext } from 'react'
import type { Provider, ProviderOrganizationResult } from '../types/organizations'

export enum ProvidersModalPurpose {
  InitialInvitation = 'InitialInvitation',
  ExtraReminder = 'ExtraReminder',
  ScheduleScreening = 'ScheduleScreening',
  ScheduleEnrichment = 'ScheduleEnrichment',
  Connect = 'Connect',
  ConnectOnlyFlow = 'ConnectOnlyFlow',
}

export interface ProvidersModalContextProps {
  isConnectDialogOpen: boolean
  handleCloseConnectDialog: () => void
  handleOpenConnectDialog: (
    providers: Provider[],
    modalPurpose: ProvidersModalPurpose,
    exactMatches?: Array<ProviderOrganizationResult>,
    templates?: Array<{ id: number; title: string }>,
    hideViewScreenedRequestsButton?: boolean,
    stepOffset?: number,
  ) => void
  providersToConnect: Provider[]
  modalPurpose: ProvidersModalPurpose
  updateProviderToConnect: (provider: Provider) => void
  exactMatches?: Array<ProviderOrganizationResult>
  templates?: Array<{ id: number; title: string }>
  hideViewScreenedRequestsButton?: boolean
  stepOffset: number
  removeProviderFromExactMatches: (providerId: number) => void
}

const ProvidersModalContext = createContext<undefined | ProvidersModalContextProps>(undefined)

export const useProvidersModal = (): ProvidersModalContextProps => {
  const context = useContext(ProvidersModalContext)
  if (context === undefined) {
    throw new Error('useProvidersModal must be used within ProvidersModalContextProvider')
  }
  return context
}

export default ProvidersModalContext
